/**
 * HTTP helpers, particulary for fetch
 *
 * See "Chaining Promises":
 *
 * https://developers.google.com/web/updates/2015/03/introduction-to-fetch?hl=en
 */

export function checkStatus(response) {
  let retStatus = null;
  if (response.status >= 200 && response.status < 300) {
    retStatus = response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return retStatus;
}


export function parseJSON(response) {
  return response.json();
}
